"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgComplete = function SvgComplete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "complete"
  }, /*#__PURE__*/React.createElement("path", {
    id: "fill-background",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.625 33.75C26.5306 33.75 33.75 26.5306 33.75 17.625C33.75 8.71941 26.5306 1.5 17.625 1.5C8.71941 1.5 1.5 8.71941 1.5 17.625C1.5 26.5306 8.71941 33.75 17.625 33.75Z",
    fill: "#2BC275"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fill-foreground",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7823 12.4831C24.254 12.8875 24.3087 13.5977 23.9043 14.0694L16.7684 22.3947C16.5683 22.6281 16.2814 22.7695 15.9743 22.7859C15.6673 22.8024 15.3669 22.6924 15.1431 22.4817L11.5255 19.0759C11.0732 18.65 11.0517 17.938 11.4776 17.4856C11.9035 17.0332 12.6155 17.0118 13.0679 17.4377L15.8272 20.0355L22.196 12.6051C22.6003 12.1334 23.3106 12.0788 23.7823 12.4831Z",
    fill: "black"
  })));
};

SvgComplete.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgComplete"
};
var _default = SvgComplete;
exports.default = _default;